var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPotChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.8;}.b{fill:url(#a);}.c{fill:url(#b);}.d{fill:url(#c);}.e{fill:url(#d);}.f{fill:url(#e);}.g{fill:url(#f);}.h,.p{fill:#fff;}.i{fill:url(#g);}.j{fill:url(#h);}.k{fill:url(#i);}.l{fill:url(#j);}.m{fill:url(#k);}.n{fill:url(#l);}.o{opacity:0.2;}.p{opacity:0.3;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: -1.646,
    x2: 1,
    y2: -1.646,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41c324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#32be12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22b800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    y1: -3.804,
    x2: 1,
    y2: -3.804,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2abc0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#21ac03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#1ea600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#177b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#177f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#198c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 2.836,
    y1: 4.806,
    x2: 3.091,
    y2: 3.808,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -0.286,
    y1: -7.649,
    x2: 1.111,
    y2: -13.218,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.255,
    y1: -8.933,
    x2: 1.998,
    y2: -13.938,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -0.208,
    y1: -10.836,
    x2: 0.634,
    y2: -18.378,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -2.071,
    y1: -15.786,
    x2: 2.282,
    y2: -15.786,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfbfbf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 14.363,
    y1: 19.093,
    x2: 16.131,
    y2: 14.44,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -12.688,
    y1: -7.283,
    x2: 1.065,
    y2: -7.283,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -0.208,
    y1: -8.357,
    x2: 1.234,
    y2: -12.898,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -0.501,
    y1: -13.089,
    x2: 0.592,
    y2: -18.916,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -0.644,
    y1: -7.29,
    x2: 2.066,
    y2: -8.203,
    xlinkHref: "#g"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11,4.329C11.024,2,8.582.045,5.545-.044S.025,1.692,0,4.022V5.447c0,2.479,2.416,4.417,5.453,4.5S10.973,8.158,11,5.754Z",
    transform: "translate(0 0.047)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5.451,65.369C2.165,65.347-.028,63.326,0,61v1.426c0,2.479,2.416,4.417,5.453,4.5S10.97,65.136,11,62.733V61.309C10.971,63.636,8.491,65.388,5.451,65.369Z",
    transform: "translate(0.003 -56.931)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M11,4.335c-.025,2.329-2.505,4.08-5.545,4.06C2.165,8.376-.028,6.354,0,4.028S2.5-.119,5.542-.037,11.021,2.008,11,4.335Z",
    transform: "translate(0.003 0.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M136.349,14.712a1.676,1.676,0,0,0,.117.147c.042.049.086.1.13.144s.093.095.142.14.1.092.156.138a.429.429,0,0,0,.112.063.642.642,0,0,0,.138.037.841.841,0,0,0,.153.011.853.853,0,0,0,.153-.017l.04-.009.039-.011.037-.014.036-.015.122-.057.119-.058.118-.058.1-.049a5.155,5.155,0,0,0-1.222-1.021l-.087.047-.106.059-.106.059a.494.494,0,0,0-.122.1.412.412,0,0,0-.078.121.294.294,0,0,0-.022.129A.232.232,0,0,0,136.349,14.712Z",
    transform: "translate(-127.983 -13.138)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M7.26,19.864c.127.086.3.213.331.232L7.6,20.1l.007,0,.007,0,.007,0a.585.585,0,0,0,.174.07.484.484,0,0,0,.172.007.419.419,0,0,0,.152-.051.352.352,0,0,0,.114-.107l.356-.542.106-.172a.233.233,0,0,0,.036-.133.372.372,0,0,0-.039-.151.6.6,0,0,0-.108-.151c-.027-.03-.166-.139-.274-.223a4.173,4.173,0,0,0-1.05,1.2Z",
    transform: "translate(-6.816 -17.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M70.847.577a.409.409,0,0,0,.16-.051.423.423,0,0,0,.122-.108A.434.434,0,0,0,71.2.271.426.426,0,0,0,71.222.1L71.214.017q-.331-.042-.672-.052a7.11,7.11,0,0,0-1.332.09l.026.1.032.119a.388.388,0,0,0,.073.139.532.532,0,0,0,.126.113A.656.656,0,0,0,69.625.6.633.633,0,0,0,69.8.636h.029l.262,0,.255-.013c.084,0,.169-.01.252-.017S70.767.585,70.847.577Z",
    transform: "translate(-64.98 0.038)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M31.835,13.692c-2.1-.059-3.819,1.19-3.838,2.792s1.673,2.947,3.775,3.006S35.591,18.3,35.61,16.7,33.937,13.751,31.835,13.692Zm-.061,5.362c-1.9-.051-3.422-1.227-3.4-2.626s1.566-2.494,3.462-2.438,3.418,1.227,3.4,2.626-1.565,2.489-3.46,2.438Z",
    transform: "translate(-26.286 -12.774)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M81.02,122.879c-.176,0-.342,0-.511-.012-.016,0-.039.057-.039.057l.018,1.548c.174.017.351.029.53.034a6.731,6.731,0,0,0,2-.235V122.69c-.3,0-.65.107-.988.143A8.872,8.872,0,0,1,81.02,122.879Z",
    transform: "translate(-75.552 -114.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M150.922,69.456a.535.535,0,0,0-.122.01.42.42,0,0,0-.106.037.367.367,0,0,0-.089.067.328.328,0,0,0-.065.086c-.035.067-.418.8-.46.875a.4.4,0,0,0-.02.344.458.458,0,0,0,.107.15.585.585,0,0,0,.175.12c.053.025.59.3.648.323a4.4,4.4,0,0,0,.306-.4,3.639,3.639,0,0,0,.235-.407,3.33,3.33,0,0,0,.175-.421.946.946,0,0,0,.092-.43c-.053-.024-.562-.258-.611-.285a.553.553,0,0,0-.067-.027.682.682,0,0,0-.067-.02.605.605,0,0,0-.066-.012C150.965,69.463,150.946,69.457,150.922,69.456Z",
    transform: "translate(-140.862 -64.823)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M165.709,75.408c-.017.034-.034.067-.053.1h0c-.017.033-.035.067-.053.1v0c-.019.033-.038.067-.057.1h0a3.836,3.836,0,0,1-.425.574h0c0,.1,0,.834.007,1.5a3.74,3.74,0,0,0,.841-1.72V74.63h0a3.269,3.269,0,0,1-.257.774Z",
    transform: "translate(-155.03 -69.653)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M7.284,78.926a.427.427,0,0,0-.1-.166l-.206-.215-.208-.213-.208-.209c-.07-.07-.078-.059-.147-.133a.683.683,0,0,0-.174-.127.731.731,0,0,0-.2-.067.6.6,0,0,0-.1-.011.629.629,0,0,0-.1,0,.524.524,0,0,0-.1.023.514.514,0,0,0-.09.043l-.462.246-.133.071a.405.405,0,0,0,.022.151,4.482,4.482,0,0,0,1.3,1.6c.02.015.038-.032.061-.045l.244-.173c.189-.133.371-.267.4-.285a.541.541,0,0,0,.152-.143.41.41,0,0,0,.07-.172A.37.37,0,0,0,7.284,78.926Z",
    transform: "translate(-4.745 -72.597)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M82.484,105.329a.477.477,0,0,0-.093-.172.668.668,0,0,0-.159-.141.638.638,0,0,0-.2-.1,7.9,7.9,0,0,0-1.222.015c-.109.009-.154.02-.257.032a.5.5,0,0,0-.2.067.529.529,0,0,0-.153.133.687.687,0,0,0-.112.4c0,.056,0,.533.021.752h0c.177.013.356.021.536.022a7.336,7.336,0,0,0,2.01-.258C82.639,106.014,82.5,105.378,82.484,105.329Z",
    transform: "translate(-75.19 -97.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M6.169,86.75V85.3a4.3,4.3,0,0,1-1.381-1.7c0,.093-.01.764-.018,1.37A4.442,4.442,0,0,0,6.169,86.75Z",
    transform: "translate(-4.478 -78.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M11,66.712c-.026,2.4-2.509,4.279-5.546,4.193S0,68.882,0,66.4v.344c0,2.479,2.416,4.417,5.453,4.5s5.52-1.792,5.547-4.195V65.63h0Z",
    transform: "translate(0 -61.253)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M5.451,63.214C2.268,63.192.11,61.3,0,59.06c0,.042,0,.086,0,.129-.024,2.328,2.168,4.349,5.455,4.371,3.038.019,5.52-1.733,5.545-4.06,0-.067,0-.14,0-.209C10.874,61.548,8.43,63.233,5.451,63.214Z",
    transform: "translate(0.003 -55.121)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotChip);
export default __webpack_public_path__ + "static/media/pot-chip.669a59ba42731152b286109ecc2e56fa.svg";
export { ForwardRef as ReactComponent };